import React from 'react';
import {
  INamedFilterFieldsFragment,
  IVirtualEventFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import EntityCategoryDetails from '../../Builder/EntitySelection/details/EntityCategoryDetails';
import UserCard from '../../UserCard';
import * as DictionaryEntityDetailsUI from './DictionaryEntityDetailsUI';
import { extractTableNamesVirtualEvent } from '../../Builder/EntitySelection/utils';

type NamedFilterFieldsOrVirtualEvent =
  | INamedFilterFieldsFragment
  | IVirtualEventFieldsFragment;
interface IProps {
  entity: NamedFilterFieldsOrVirtualEvent;
}

const DictionaryEntityBasicDetails = ({ entity }: IProps) => {
  const tableNames = extractTableNames(entity);
  return (
    <DictionaryEntityDetailsUI.Container>
      <DictionaryEntityDetailsUI.Description>
        {entity.description && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              Description:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {entity.description}
          </>
        )}
        {tableNames.length > 0 && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              {tableNames.length > 1 ? 'Tables' : 'Table'}:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {tableNames.join(', ')}
          </>
        )}
        {entity.comment && (
          <>
            <DictionaryEntityDetailsUI.DescriptionTerm>
              Comment:
            </DictionaryEntityDetailsUI.DescriptionTerm>
            {entity.comment}
          </>
        )}
      </DictionaryEntityDetailsUI.Description>
      {entity.creator && <UserCard user={entity.creator} size="small" />}
      {entity.categories?.length > 0 && (
        <EntityCategoryDetails entityCategories={entity.categories} />
      )}
    </DictionaryEntityDetailsUI.Container>
  );
};

function extractTableNames(entity: NamedFilterFieldsOrVirtualEvent): string[] {
  if (entity.__typename === 'VirtualEvent') {
    return extractTableNamesVirtualEvent(entity);
  }
  return [];
}

export default DictionaryEntityBasicDetails;
